import React, { useEffect, useState } from "react";
import { Tabs, Tab, Card, Button, Row, Col, Modal } from "react-bootstrap";
import RewardCard from "../components/RewardCard";
import { rewardService } from "../services";

import Notification from "./Notification";
import ClaimedRewards from "./ClaimedRewards";
import Booking from "./Booking";
import Activity from "./Activity";

const Home = () => {
  const [myrewards, setMyRewards] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0); 

  useEffect(() => {
    getMyRewardsList();
  }, []);

  // Fetch_Rewards_List
  const getMyRewardsList = async () => {
    try {
      const res = await rewardService.getMyRewards();
      if (res && res.data) {
        setMyRewards(res.data);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    }
  };

  return (
    <div className="four-tabs-design11">
      <Tabs defaultActiveKey="claimed" className="listing-tabs w-100">
        {/* Claimed Rewards Tab */}
        <Tab
          eventKey="claimed"
          title="CLAIMED REWARDS"
          tabClassName="custom-tab"
        >
          <ClaimedRewards />
        </Tab>

        {/* Bookings Tab */}
        <Tab eventKey="bookings" title="BOOKINGS" tabClassName="custom-tab">
          <Booking />
        </Tab>

        {/* Activity Tab */}
        <Tab eventKey="activity" title="ACTIVITY" tabClassName="custom-tab">
          <Activity />
        </Tab>

        {/* Notifications Tab */}
        <Tab
          eventKey="notifications"
          // title="NOTIFICATIONS"
          title={
            <>
              NOTIFICATIONS
              {unreadCount > 0 && <span className="notif-dot" />}
            </>
          }
         tabClassName="custom-tab"
          
        >
          <Notification onUnreadChange={setUnreadCount}/>
        </Tab>
      </Tabs>
    </div>
  );
};

export default Home;
